<template>
    <nav class="sjl-pagination-content" aria-label="Pagination">
        <ul class="sjl-pagination-list p-0">
            <li class="sjl-page-prev" :class="{ disabled: !goBack }">
                <a :href="goBack ? backurl : null" :aria-disabled="!goBack" :tabindex="goBack ? null : -1" rel="prev">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"></polyline></svg>
                    <span>{{ $trans('messages.back') }}</span>
                </a>
            </li>

            <li class="sjl-page-current" aria-current="page">{{ $trans('messages.page') }} {{ page }}</li>

            <li class="sjl-page-next" :class="{ disabled: !goForward }">
                <a :href="goForward ? forwardurl : null" :aria-disabled="!goForward" :tabindex="goForward ? null : -1" rel="next">
                    <span>{{ $trans('messages.next') }}</span>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"></polyline></svg>
                </a>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    props: ['jobs'],
    data() {
        return {
            page: 1,
            goBack: false,
            goForward: true,
            backurl: window.location.href.split('?')[0],
            forwardurl: window.location.href.split('?')[0]
        }
    },
    methods: {
        analyizelist() {
            var queryString = window.location.search;
            var urlParamsOne = new URLSearchParams(queryString);
            var urlParamsTwo = new URLSearchParams(queryString);
            if(urlParamsOne.has('jobstatus')){
              urlParamsOne.delete('jobstatus');
            }
            if(urlParamsTwo.has('jobstatus')){
              urlParamsTwo.delete('jobstatus');
            }
            if(urlParamsOne.has('page')){
                let page = parseInt(urlParamsOne.get('page'));
                if(page > 1){
                    this.goBack = true;
                    if(page == 2){
                        urlParamsOne.delete('page');
                    }else {
                        page--;
                        urlParamsOne.set('page', page);
                    }
                }
            }

            if(urlParamsTwo.has('page')){
                let page2 = parseInt(urlParamsTwo.get('page'));
                this.page = page2 > 0 ? page2 : 1;
                if(page2 <= 5){
                    page2++;
                } else {
                    // Six pages is the cap; Next used to link back to the page itself.
                    this.goForward = false;
                }
                urlParamsTwo.set('page', page2);
            }else {
                urlParamsTwo.set('page', 2);
            }
            this.backurl = this.backurl+"?"+urlParamsOne.toString();
            this.forwardurl = this.forwardurl+"?"+urlParamsTwo.toString();
        }

    },
    async mounted() {
        this.analyizelist();
    }
}
</script>
